module.exports = __webpack_public_path__ + "img/BANNER_SLOT.9888a33b.svg";